import { render, staticRenderFns } from "./AppendixOnUs.vue?vue&type=template&id=318ae9dc&scoped=true"
import script from "./AppendixOnUs.vue?vue&type=script&lang=js"
export * from "./AppendixOnUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ae9dc",
  null
  
)

export default component.exports